import styled from 'styled-components'
import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { networkLogos } from 'src/constants'

export default (props) => {
  return (
    <StyledContainer>
      <USTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        addonCode="deportes"
        video="https://assets.fubo.tv/marketing/lp/videos/compressed/CFB_SEC_16x9_10s_LP_3Mb.mp4"
        videoMobile="https://assets.fubo.tv/marketing/lp/videos/mobile/CFB_SEC_1x1_10s_LP_3Mb.mp4"
        staticAnnotation={networkLogos.espn}
        title="Watch SEC Network with Fubo"
        subtitle="Live games, news, analysis and more"
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
